var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.125a4.151 4.151 0 00-1.193.195c.179.322.274.685.276 1.055a2.23 2.23 0 01-.626 1.547 2.137 2.137 0 01-.694.474c-.26.11-.538.166-.819.166a2.08 2.08 0 01-1.03-.282c-.249.88-.22 1.817.082 2.68a4.353 4.353 0 001.599 2.124 4.2 4.2 0 002.512.767 4.207 4.207 0 002.476-.88 4.365 4.365 0 001.506-2.194 4.458 4.458 0 00-.032-2.68 4.357 4.357 0 00-1.56-2.156A4.202 4.202 0 0012 8.125zm10.867 3.805C20.796 7.796 16.695 5 12 5 7.305 5 3.203 7.798 1.133 11.93a1.287 1.287 0 000 1.14C3.204 17.203 7.305 20 12 20c4.695 0 8.797-2.798 10.867-6.93a1.286 1.286 0 000-1.14zM12 18.125c-3.768 0-7.222-2.148-9.088-5.625C4.778 9.023 8.232 6.875 12 6.875c3.768 0 7.222 2.148 9.088 5.625-1.865 3.477-5.32 5.625-9.088 5.625z",
    fill: "#777"
  })));
}

export default SvgEyeShow;